import { createAction, props } from '@ngrx/store';
import { StaticItem } from 'shared/base/generics/models/static-item';

export enum QuoteConfigActionTypes {
    CHECK_CONTACT_VALIDITY = '[quote - config] check contact validity',
    CHECK_CONTACT_VALIDITY_RESPONSE = '[quote - config] check contact validity response',
    CHECK_ANONYMOUS_CONTACT_VALIDITY = '[quote - config] check anonymous contact validity',
    CHECK_ANONYMOUS_CONTACT_VALIDITY_RESPONSE = '[quote - config] check anonymous contact validity response',
}

export const checkContactValidityRequest = createAction(
    QuoteConfigActionTypes.CHECK_CONTACT_VALIDITY,
);

export const checkContactValidityResponse = createAction(
    QuoteConfigActionTypes.CHECK_CONTACT_VALIDITY_RESPONSE,
    props<{ dropOffState: StaticItem }>(),
);

export const checkAnonymousContactValidityRequest = createAction(
    QuoteConfigActionTypes.CHECK_ANONYMOUS_CONTACT_VALIDITY,
    props<{ contactNumber: string }>(),
);

export const checkAnonymousContactValidityResponse = createAction(
    QuoteConfigActionTypes.CHECK_ANONYMOUS_CONTACT_VALIDITY_RESPONSE,
    props<{ dropOffState: StaticItem }>(),
);
